import { Route, Switch } from "react-router-dom";

import { USER_ROUTES } from "../../utils/routeConstants";
import AgentRoutesManagementScreen from "../AdminDocumentManagementScreen/AgentRoutesManagementScreen";
import InitialLayout from "../InitialLayout/InitialLayout";

function ImportFlow(props: any) {
  return (
    <Switch>
      <Route path={USER_ROUTES.IMPORTS.path}>
        <InitialLayout
          userInfo={props.userInfo}
          updateLogged={props.updateLogged}
        >
          <AgentRoutesManagementScreen
            userCompanyMe={props.userInfo.company}
            userProfileMe={props.userInfo.profile}
            userInfo={props.userInfo}
          />
        </InitialLayout>
      </Route>
    </Switch>
  );
}

export default ImportFlow;
